import { NavLink } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface NavItem {
    to: string;
    icon: LucideIcon;
    label: string;
}

interface BottomNavProps {
    navItems?: NavItem[];
}

export default function BottomNav({ navItems = [] }: BottomNavProps) {
    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-dark-surface/90 backdrop-blur-lg border-t border-dark-border safe-bottom z-50">
            <div className="flex justify-around items-center max-w-2xl mx-auto px-2">
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center min-h-[64px] flex-1 transition-all duration-200 ${isActive
                                ? 'text-accent-purple transform scale-105'
                                : 'text-dark-muted hover:text-dark-text'
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <item.icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                                <span className="text-[8px] mt-1 font-black tracking-widest uppercase truncate max-w-full px-1 group-hover:text-dark-text transition-colors">
                                    {item.label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
